import { axios } from "@/client/libs/axios";
import { queryClient } from "@/client/libs/query-client";
import { useMutation } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { RateDto, UpdateRateDto } from "libs/dto/src/rate";

const updateRate = async (id: string, data: UpdateRateDto) => {
  const response = await axios.patch<RateDto, AxiosResponse<RateDto>>(`rates/${id}`, data);
  return response.data;
};

export const useUpdateRate = () => {
  const {
    error,
    isPending: loading,
    mutateAsync: updateRateFn,
  } = useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateRateDto }) => updateRate(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["all-rate"] });
    },
  });

  return { updateRate: updateRateFn, error, loading };
};
